import config from 'config/default';
import { Browser } from 'enums';
import { useEffect, useState } from 'react';

const useBrowser = () => {
  const [userBrowser, setUserBrowser] = useState<Browser>();

  const extensionStoreURL = userBrowser === Browser.MS_EDGE_CHROMIUM ? config.extensionEdgeStoreURL : config.extensionChromeStoreURL;

  const hasPwManagerLink =
    userBrowser === Browser.MS_EDGE_CHROMIUM || userBrowser === Browser.CHROME || userBrowser === Browser.FIREFOX || userBrowser === Browser.SAFARI;

  useEffect(() => {
    // browser detection from https://codepedia.info/detect-browser-in-javascript
    const browserName = ((agent) => {
      switch (true) {
        case agent.indexOf('edge') > -1:
          return Browser.MS_EDGE_OLD;
        case agent.indexOf('edg/') > -1:
          return Browser.MS_EDGE_CHROMIUM;
        case agent.indexOf('opr') > -1 && !!(window as any).opr:
          return Browser.OPERA;
        case agent.indexOf('chrome') > -1 && !!(window as any).chrome:
          return Browser.CHROME;
        case agent.indexOf('trident') > -1:
          return Browser.MS_IE;
        case agent.indexOf('firefox') > -1:
          return Browser.FIREFOX;
        case agent.indexOf('safari') > -1:
          return Browser.SAFARI;
        default:
          return Browser.OTHER;
      }
    })(window.navigator.userAgent.toLowerCase());

    setUserBrowser(browserName);
  }, []);

  return { userBrowser, extensionStoreURL, hasPwManagerLink };
};

export default useBrowser;
